import { Pause, Pin, Play } from "lucide-react";
import { PRODUCT_LABEL, PRODUCT_SLUG, fmt } from "../lib/constants";
import { HINT } from "./HowWeCount";

export const viewName = (v) => (v === "all" ? "All venues" : PRODUCT_LABEL[v] || v);

export const RotationControls = ({ views, active, pinned, paused, progress, counts, onPause, onPin }) => {
  const count = counts[active];
  return (
    <div className="flex items-start justify-between gap-3" data-testid="rotation-controls">
      <div data-testid="map-view-banner" className="min-w-0" title={HINT.map}>
        <div className="eyebrow">On the map</div>
        <div className="flex items-baseline gap-3 tv:gap-[15px] mt-0.5 flex-wrap">
          <span className="font-extrabold tracking-tight text-2xl tv:text-[37px] leading-none text-ink truncate">{viewName(active)}</span>
          <span data-testid="map-view-count" className="num font-bold text-brand text-xl tv:text-[32px] leading-none">
            {typeof count === "number" ? fmt(count) : count}
          </span>
        </div>
        <div className="flex items-center gap-1.5 tv:gap-[8px] mt-2 tv:mt-[11px]" data-testid="rotation-segments">
          {views.map((v) => {
            const isActive = v === active;
            const isPinned = v === pinned;
            return (
              <button
                key={v}
                type="button"
                data-testid={`rotation-pin-product-${PRODUCT_SLUG(v)}`}
                onClick={() => onPin(v)}
                title={isPinned ? `${viewName(v)} – pinned, click to unpin` : `Show ${viewName(v)}`}
                aria-label={viewName(v)}
                className={`relative h-1.5 tv:h-[9px] rounded-full overflow-hidden transition-all duration-300 ${isActive ? "w-12 tv:w-[65px] bg-slate-200" : "w-5 tv:w-[28px] bg-slate-200 hover:bg-slate-300"}`}
              >
                {isActive && <span className="absolute inset-y-0 left-0 bg-brand rounded-full" style={{ width: `${paused || pinned ? 100 : Math.max(progress * 100, 4)}%`, transition: "width 200ms linear" }} />}
              </button>
            );
          })}
          {pinned && (
            <span className="inline-flex items-center gap-1 text-[10px] tv:text-[13px] font-semibold text-slate-500 ml-1" data-testid="rotation-pinned-label">
              <Pin className="w-3 h-3 tv:w-[14px] tv:h-[14px]" /> pinned
            </span>
          )}
        </div>
      </div>
      <button
        type="button"
        data-testid="rotation-pause-button"
        onClick={onPause}
        aria-pressed={!paused}
        title={paused ? "Rotation is off – click to cycle the map through the products every 15 s" : "Rotation is on – click to stop on the current view"}
        className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 tv:px-[15px] tv:py-[8px] text-xs tv:text-[15px] font-semibold shadow-sm transition-colors shrink-0 ${paused ? "border-panel-border bg-panel text-slate-700 hover:border-slate-400" : "border-brand/40 bg-brand/5 text-brand hover:bg-brand/10"}`}
      >
        {paused ? <Play className="w-3.5 h-3.5 tv:w-[17px] tv:h-[17px]" /> : <Pause className="w-3.5 h-3.5 tv:w-[17px] tv:h-[17px]" />}
        Rotation: {paused ? "off" : "on"}
      </button>
    </div>
  );
};
